import { useState } from 'react';
import { ItemStatusList } from '../../../../interface/aiAnalyze/aiRecommend/data';
import BottomModal from '../../../components/modal/BottomModal';
import {
  CancleButton,
  ConfirmButton,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '../../../components/modal/Modal.style';
import {
  ModalInfo,
  Section,
  Option,
  SelectContent,
} from './SelectModal.styles';

interface Props {
  selected: string; // 단일 선택
  onApply: (selected: string) => void;
  onClose: () => void;
}

const ItemCategoryModal = ({ selected, onApply, onClose }: Props) => {
  const [selectedItem, setSelectedItem] = useState(selected);

  const toggleItem = (item: string) => {
    setSelectedItem((prev) => (prev === item ? '' : item)); // 단일 선택
  };

  const isChecked = (value: string) => selectedItem === value;

  const handleApply = () => {
    onApply(selectedItem);
    onClose();
  };

  return (
    <BottomModal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>투자 물건</ModalTitle>
        <ModalCloseButton
          onClick={onClose}
          src="/assets/images/close/close-dark-gray.svg"
          alt="close"
        />
      </ModalHeader>
      <Section $gap={16}>
        <ModalInfo>관심있는 물건 종류를 선택해주세요</ModalInfo>
        <SelectContent>
          {ItemStatusList.filter((i) => i.label !== '전체').map((group) => (
            <Option key={group.label} $active={isChecked(group.label)}>
              <label>
                <input
                  type="checkbox"
                  checked={isChecked(group.label)}
                  onChange={() => toggleItem(group.label)}
                />
                {group.label}
                {isChecked(group.label) && (
                  <img
                    src="/assets/images/check/blue_check_24.svg"
                    onClick={() => toggleItem(group.label)}
                    alt=""
                  />
                )}
              </label>
            </Option>
          ))}
        </SelectContent>
      </Section>
      <ModalFooter>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton $disabled={selectedItem === ''} onClick={handleApply}>
          적용
        </ConfirmButton>
      </ModalFooter>
    </BottomModal>
  );
};

export default ItemCategoryModal;
